export default __webpack_public_path__ + "static/media/MobileApp.65a79b66.png";